module.exports = __webpack_public_path__ + "img/logo.cc6359a2.svg";